<template>
	<div class="solution-container">
		<div class="accordion-banner">
			<ul class="banner-ul" >
				<li class="banner-li" v-for="(item,index) in caseList" :key="index" ref="clearfix" :class="{'max-title':hoverIndex === index}" @mouseover="handleOver($event,index,true)" @mouseout="handleOver($event,index)" >
					<div class="bgm-div" :style="'background-image:url(' + item.url + ')'">
						<div class="according-title" v-show="hoverIndex !== index">{{item.name}}</div>
						<div class="according-write" v-show="hoverIndex == index">
							<div class="according-name">{{item.name}}</div>
							<div class="according-describe">{{item.instructions}}</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="content-block-wrapper case-show-wrapper">
			<div class="content-block flex-col">
				<h3 class="content-title">飞渡数字智慧园区解决方案</h3>
				<div class="content-main">
				<div class="row-item" v-for="(item,index) in provideServices" :key="index">
					<div class="img-block">
						<em class="icon-img" :class="{[item.icon]:true}" alt=""></em>
					</div>
					<div class="text-block">
						<h3 class="text-title">{{item.title}}</h3>
						<p class="text-detail">{{item.detail}}</p>
					</div>
				</div>
				</div>
			</div>
		</div>
		<div class="content-block-wrapper">
			<div class="content-block flex-between" v-for="(item,index) in provideDetailList" :class="index%2?'right-content-block':''" :key="index">
				<img class="service-img wow animate__fadeInLeft" :src="item.serviceImg" alt="" width="100%" data-wow-duration="1.2s">
				<div class="service-content-main content-main flex-col">
					<div class="text-block wow animate__fadeInLeft" data-wow-duration="1.2s">
						<h3 class="sub-title">{{item.serviceName}}</h3>
						<p class="service-detail text-detail">{{item.serviceDetail}}</p>
					</div>
					<div class="icon-block-wrapper-more wow animate__fadeInUp" v-if="item.roleList.length > 5" data-wow-duration="1.2s">
						<div class="icon-block" v-for="(role,index) in item.roleList" :key="index">
							<em class="icon-img" :class="{[role.roleIcon]:true}" alt=""></em>
							<p class="icon-text">{{role.roleName}}</p>
						</div>

					</div>
					<div class="icon-block-wrapper wow animate__fadeInUp" v-else data-wow-duration="1.2s">
						<div class="icon-block" v-for="(role,index) in item.roleList" :key="index">
							<em class="icon-img" :class="{[role.roleIcon]:true}" alt=""></em>
							<p class="icon-text">{{role.roleName}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content-block-wrapper">
			<div class="content-architecture">
				<div class="title-wrapper">
					<div class="title-link">
						<div class="title-h1">
							<span>我们的方案架构</span>
						</div>
						<div name="content" class="title-content" style="text-align:center">
							<span>结合物联网信息技术，打造智慧社区平台。</span>
						</div>
					</div>
				</div>
				<div class="architecture-row">
					<img src="/static/images/solution/solution-programe.png" alt="方案架构">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {provideServices, caseList, provideDetailList,caseWrapperList} from './data.js'
export default {
	data(){
		return{
			caseList: caseList,
			provideServices: provideServices,
			provideDetailList: provideDetailList,
			caseWrapperList: caseWrapperList,
			hoverIndex:0,
		}
	},
	methods: {
		handleOver(val, hoverIndex,isOver = false){
			this.hoverIndex = hoverIndex;
		}
	}
}
</script>
<style scoped lang="scss">
@import '@/assets/css/solution.scss';
</style>


// WEBPACK FOOTER //
// src/components/solution/solution.vue